
class Teamwant{
  constructor(element, config) {
    console.log('teamwant :)')
    var t = this;

    t.fixedMenu()
    window.addEventListener('scroll', function() {
      t.fixedMenu()
    });

  }

  customNavToggler(){
    document.querySelectorAll('[data-toggle="tab"][data-secound]').forEach(function (item) {
      item.addEventListener('click', function (e) {
        const elem = document.querySelector(item.dataset.secound)
        if (!elem.classList.contains('show')) {
          const parent = elem.parentElement.querySelector('.active')
          parent.classList.remove('show')

          setTimeout(function () {
            parent.classList.remove('active')
            elem.classList.add('active', 'show')
          }, 200)
        }
      })
    })
  }

  customMap(){
    var map = document.querySelector('#user_map')
    if(map){
      mapboxgl.accessToken =
        "pk.eyJ1IjoiZ3VoYWdlaG8iLCJhIjoiY2pvdHV5d2VtMDFzZTNyb2RsMDZ0emNscCJ9.lqHVCmqM3kt6YT45ifgDqw"

      /* Map: This represents the map on the page. */
      map = new mapboxgl.Map({
        container: "user_map",
        style: "mapbox://styles/mapbox/streets-v10",
        zoom: 6.3,
        center: [50, 50]
      })

      map.on("load", function() {
        /* Image: An image is loaded and added to the map. */
        map.loadImage(" ", function(error, image) {
          if (error) throw error
          map.addImage("custom-marker", image)
          /* Style layer: A style layer ties together the source and image and specifies how they are displayed on the map. */
          map.addLayer({
            id: "markers",
            type: "symbol",
            /* Source: A data source specifies the geographic coordinate where the image marker gets placed. */
            source: {
              type: "geojson",
              data: {
                type: "FeatureCollection",
                features: [
                  {
                    type: "Feature",
                    geometry: {
                      type: "Point",
                      coordinates: [50, 50]
                    }
                  }
                ]
              }
            },
            layout: { "icon-image": "custom-marker" }
          })
        })
      }) // $(this).addClass('someClass') // $('#profile').trigger('cssClassChanged') setTimeout(function() {
      map.resize()
    }
  }

  fixedMenu(){
    const menu = document.querySelector('.header .navbar ul .nav-item .nav-link');
    const menu2 = document.querySelector('.header-fixed');
    if(window.pageYOffset > (menu.getBoundingClientRect().y + menu.getBoundingClientRect().height + 20)){
      menu2.classList.add('fixed')
    }else{
      menu2.classList.remove('fixed')
    }

    // var target_list = []
    // document.querySelectorAll('.header .navbar ul .nav-item .nav-link').forEach(function (elem) {

    //   if(!elem.attributes.href.nodeValue || elem.attributes.href.nodeValue == '#'){
    //     return;
    //   }

    //   const target = document.querySelector(elem.attributes.href.nodeValue)
    //   console.log(target)
    //   if (target && target.length) {
    //     target_list.push({
    //       pos: target.getBoundingClientRect().y,
    //       item: target
    //     })
    //     // if (window.pageYOffset > (target.getBoundingClientRect().y - 50)) {
    //     //   elem.parentElement.classList.add('active')
    //     // }else{
    //     //   elem.parentElement.classList.remove('active')
    //     // }
    //   }
    // })


    // document.querySelectorAll('.header-fixed .navbar ul .nav-item .nav-link').forEach(function (elem) {

    //   if(!elem.attributes.href.nodeValue || elem.attributes.href.nodeValue == '#'){
    //     return;
    //   }

    //   const target = document.querySelector(elem.attributes.href.nodeValue)
    //   if (target && target.length) {
    //     target_list.push({
    //       pos: target.getBoundingClientRect().y,
    //       item: target
    //     })
    //     // if (window.pageYOffset > (target.getBoundingClientRect().y - 50)) {
    //     //   elem.parentElement.classList.add('active')
    //     // }else{
    //     //   elem.parentElement.classList.remove('active')
    //     // }
    //   }
    // })

    // var selected = 0
    // var window50vh = window.innerHeight / 2;
    // for (var i = 0; i < (target_list.length); i++){
    //   // if((target_list[i].pos - 50 + window.pageYOffset) < window.pageYOffset){
    //   //   selected = target_list[i]
    //   //   break
    //   // }
    //   var next = i + 1;
    //   if(target_list[next]){
    //     if((target_list[i].pos - window50vh) <= 1 && (target_list[next].pos - window50vh) > 0){
    //       selected = target_list[i]
    //     }
    //   }else{

    //     if((target_list[i].pos - window50vh) <= 1){
    //       selected = target_list[i]
    //     }
    //   }

    // }


    // // console.log('select:')
    // // console.log(selected);
    // // console.log(target_list);


    // document.querySelectorAll('.header .navbar ul .nav-item .nav-link').forEach(function (elem) {
    //   if(selected){
    //     if(elem.attributes.href.nodeValue == '#'+selected.item.attributes.id.nodeValue){
    //       elem.parentElement.classList.add('active')
    //     }else{
    //       elem.parentElement.classList.remove('active')
    //     }
    //   }
    // })

  }
  animate(elem, style, unit, from, to, time, prop) {
    if (!elem) {
      return;
    }
    var start = new Date().getTime(),
      timer = setInterval(function () {
        var step = Math.min(1, (new Date().getTime() - start) / time);
        if (prop) {
          elem[style] = (from + step * (to - from))+unit;
        } else {
          elem.style[style] = (from + step * (to - from))+unit;
        }
        if (step === 1) {
          clearInterval(timer);
        }
      }, 25);
    if (prop) {
      elem[style] = from+unit;
    } else {
      elem.style[style] = from+unit;
    }
  }
}

document.addEventListener("DOMContentLoaded", new Teamwant());
export default Teamwant



